import { useEffect } from 'react'
import { fetchBookingVendorConfiguration } from 'actions/CruiseActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'

interface Props {
  departureId?: string
}

export default function useCruiseVendorConfiguration({ departureId }: Props) {
  const dispatch = useAppDispatch()
  const vendorConfiguration = useAppSelector((state) => {
    return departureId ? state.cruise.multiBooking.vendorConfiguration?.[departureId] : undefined
  })

  useEffect(() => {
    if (!departureId || vendorConfiguration) return

    dispatch(fetchBookingVendorConfiguration(departureId))
  }, [departureId, dispatch, vendorConfiguration])

  return vendorConfiguration
}
